export const en = {
  translation: {
    header: {
      title: 'hellow world',
    },
  },
}
